import Enum from './enum'

class ReductionSpecFilter extends Enum
{
  constructor(value) {
    super(value);
  }
}

ReductionSpecFilter.init({
  NONE: 'None',
  MY_BID: 'MyBid',
  NO_MY_BID: 'NoMyBid',
  LEADER: 'Leader',
  NOT_LEADER: 'NotLeader'
});

export default ReductionSpecFilter;
